import { useMemo } from 'react'
import { getRulesConfig, hasRules, isVacationSlug } from '../config'

export const useGiveawayRules = (theatricalSlug: string) => {
  return useMemo(() => {
    const config = getRulesConfig(theatricalSlug)
    const rulesExist = hasRules(theatricalSlug)

    return {
      rulesConfig: config,
      hasRules: rulesExist,
      isVacationSlug: isVacationSlug(theatricalSlug),
    }
  }, [theatricalSlug])
}
